module.exports = [{
      plugin: require('/home/circleci/portfolio/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-123731367-1","head":false},
    },{
      plugin: require('/home/circleci/portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
